export enum AppAction {
  INIT = 'APP_INIT',
}
